import BaseComponentController from '../../../../components/base-component.controller';
import { ReturnAssessmentOptionText } from '../../../../constants/inputText';

class GiftManagementStrategyController extends BaseComponentController {
    constructor(_, componentRegistryService, $q) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors:[]
        };
        this.ReturnAssessmentOptionText = ReturnAssessmentOptionText;
        this.defaultValue = "n/a";
    }

    init() {
        this.vm = {
            errors:[]
        };
        if (this._.isEmpty(this.model)) {
            this.model = {
                selectedOption: null
            };
        }
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this._.isEmpty(this.model.selectedOption)) {
            this.vm.errors= [`Please select a management strategy`];
        } else {
            this.vm.errors = [];
        }
        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    managementStrategySelected() {
        this.vm = {
            errors: []
        };
    
        this.onManagementStrategyRequired({ managementStrategyRequired : this.model.selectedOption });
    }
}

GiftManagementStrategyController.$inject = ['_', 'componentRegistryService', '$q'];

let giftManagementStrategyComponent = {
    controller: GiftManagementStrategyController,
    bindings: {
        managementStrategies: '<',
        readonly: '<',
        modelName: '@',
        onManagementStrategyRequired: '&'
    },
    templateUrl:`app/assess/gift/components/gift-management-strategy/gift-management-strategy.html`
};

export default giftManagementStrategyComponent;


// WEBPACK FOOTER //
// ./app/assess/gift/components/gift-management-strategy/gift-management-strategy.component.js